

export const relatorioDetalhadoFilaMethods = {
  toggleStatus() {
    this.$nextTick(() => {
      if (this.todosStatusSelecionados) {
        this.form.status.splice(0);
      } else {
        this.form.status.splice(0);
        this.form.status = this.status.map((stat) => stat.value);
      }
    });
  },
  toggleCentroDeCustos() {
    this.$nextTick(() => {
      if (this.todosCentrosDeCustosSelecionados) {
        this.form.centrosDeCusto.splice(0);
      } else {
        this.form.centrosDeCusto.splice(0);
        this.form.centrosDeCusto = this.centrosDeCusto.map(
          (centroDeCusto) => centroDeCusto.value
        );
      }
    });
  },
  numeroOrigemFormer(numero) {
    const numeroIntermediario = numero.split(",");
    const numeroArray = [];

    numeroIntermediario.forEach((numeros) => {
      if (typeof numeros.split("-")[1] === "undefined") {
        numeroArray.push(numeros);
      } else {
        const inicioRange = numeros.split("-")[0];
        const finalRange = numeros.split("-")[1];
        if (inicioRange > finalRange) {
          window.alert("Início do range não pode ser maior que final do range");
          return;
        }

        for (let i = inicioRange; i <= finalRange; i++) {
          numeroArray.push(i.toString());
        }
      }
    });

    return numeroArray;
  },
  maiorQueFormer(numero){
    var p = numero.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
  },
  menorQueFormer(numero){
    var p = numero.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
  },
  all() {
    this.mostrar = !this.mostrar;
    for (let i = 0; i <= this.chamadasRelatorio.length; i++) {
      this.panel.push(i);
    }
  },
  none() {
    this.mostrar = !this.mostrar;
    this.panel = [];
  },
  async gerar() {
    this.$v.$touch();
    if (this.$v.$error) {
      this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
      return;
    }

    // Caso outro relatorio tenha sido gerado, fecha itens que estiverem abertos antes de gerar outro
    this.panel.splice(0);
    // =====

    

    this.currentPage = 0;
    this.showReport = false;
    this.showSkeleton = true;
    this.chamadasRelatorio.splice(0);


    this.form.dateTimeRange = this.dateTimeRange;

    await this.gerarRelatorio(this.form);
    this.chamadasRelatorio = [...this.getDadosRelatorio];
    this.currentPage = 1;

    this.totalItems = this.getDadosRelatorio.length;

    this.showSkeleton = false;
    this.showReport = true;
  },
  async firstPage() {
    if (this.currentPage > 1) {
      this.currentPage = 1;
    }
  },
  async formerPage() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
    }
  },
  async nextPage() {
    if (this.currentPage < this.lastPageItem) {
      this.currentPage = this.currentPage + 1;
    }
  },
  async lastPage() {
    if (this.currentPage < this.lastPageItem) {
      this.currentPage = this.lastPageItem;
    }
  },
};
